import React from 'lib/react';
import { useTranslation } from 'lib/translation';
import { EVTabs, EVTab, makeStyles } from 'lib/components';
import PropTypes from 'prop-types';
import clsx from 'lib/clsx';
import NewBadge from 'commonComponents/newBadge';

const useStyles = makeStyles((theme) => ({
  tabs: {
    minWidth: 'fit-content',
    backgroundColor: theme.evPalette.charcoal[100],
    borderRadius: '24px',
    padding: '6px',
    maxHeight: 'fit-content',
  },
  scroller: {
    maxHeight: 'fit-content',
  },
  tab: {
    textTransform: 'none',
    padding: '0 16px',
    minWidth: 'fit-content',
    border: 'none',
    opacity: 1,
  },
  tabSelected: {
    borderRadius: '20px',
    backgroundColor: '#5BAB84',
    color: theme.evPalette.salt[100],
  },
  tabWrapper: {
    flexDirection: 'row',
    gap: '8px',
  },
  indicator: {
    display: 'none',
  },
}));

function MapProviderToggle({
  useEmbeddedExplorer,
  onToggle,
  className,
  disabled,
  ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const value = useEmbeddedExplorer ? 'embedded' : 'bing';

  const handleChange = (_, newValue) => {
    if (newValue !== value) {
      onToggle();
    }
  };

  return (
    <EVTabs
      value={value}
      onChange={handleChange}
      variant="standard"
      className={clsx(classes.tabs, className)}
      classes={{
        indicator: classes.indicator,
        scroller: classes.scroller,
      }}
      {...rest}
    >
      <EVTab
        label={t('map_provider_toggle__switch_to_bing_maps')}
        value="bing"
        className={classes.tab}
        classes={{
          selected: classes.tabSelected,
        }}
        disabled={disabled}
      />
      <EVTab
        label={(
          <>
            {t('map_provider_toggle__switch_to_embedded_explorer')}
            <NewBadge label="Beta" />
          </>
        )}
        value="embedded"
        className={classes.tab}
        classes={{
          selected: classes.tabSelected,
          wrapper: classes.tabWrapper,
        }}
        disabled={disabled}
      />
    </EVTabs>
  );
}

MapProviderToggle.defaultProps = {
  className: '',
  disabled: false,
};

MapProviderToggle.propTypes = {
  useEmbeddedExplorer: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default MapProviderToggle;
